import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { url } from 'configs/';
const newsSettingPath = 'tube/company-space/news-setting/';
const FETCH_NEWS_SETTING = `${newsSettingPath}FETCH_NEWS_SETTING`;
const UPDATE_NEWS_SETTING = `${newsSettingPath}UPDATE_NEWS_SETTING`;

const internalSystemLinkSettingPath = 'tube/company-space/internal-system-link-setting/';
const FETCH_INTERNAL_SYSTEM_LINK = `${internalSystemLinkSettingPath}FETCH_INTERNAL_SYSTEM_LINK`;
const ADD_INTERNAL_SYSTEM_LINK = `${internalSystemLinkSettingPath}ADD_INTERNAL_SYSTEM_LINK`;
const UPDATE_INTERNAL_SYSTEM_LINK = `${internalSystemLinkSettingPath}UPDATE_INTERNAL_SYSTEM_LINK`;
const DELETE_INTERNAL_SYSTEM_LINK = `${internalSystemLinkSettingPath}DELETE_INTERNAL_SYSTEM_LINK`;

const initialState = {
  data: [],
  isLoading: true,
  isLoaded: true,
  carouselSecond: 10,
  internalSystemLinkSetting: {
    datas: [],
    isLoading: false,
    pageCount: 0,
    pageSize: 5,
    pageNumber: 1,
  },
};

export default typeToReducer({
  [FETCH_NEWS_SETTING]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true, isLoaded: false, data: [] });
    },
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: true, data: action.payload.data });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: false, data: [] });
    },
  },
  [UPDATE_NEWS_SETTING]: {
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, { carouselSecond: action.payload.data });
    },
  },
  [FETCH_INTERNAL_SYSTEM_LINK]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, {
        internalSystemLinkSetting: Object.assign({}, state.internalSystemLinkSetting, { isLoading: true }),
      });
    },
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, {
        internalSystemLinkSetting: Object.assign({}, state.internalSystemLinkSetting, {
          datas: action.payload.response.data.items,
          isLoading: false,
          pageCount: action.payload.response.data.count,
          pageNumber: action.payload.pageNumber,
        }),
      });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, {
        internalSystemLinkSetting: Object.assign({}, state.internalSystemLinkSetting, { isLoading: false }),
      });
    },
  },
}, initialState);

export function fetchNewsSetting() {
  return {
    type: FETCH_NEWS_SETTING,
    payload: axios.get(`${url.SECURITY_API_SERVER}system/COMP_AnnouncementCategory/GetAll`, {
      params: {
        language: 'zh-tw',
      },
    }),
  };
}

export function updateNewsSetting(data) {
  return {
    type: UPDATE_NEWS_SETTING,
    payload: axios.put(`${url.SECURITY_API_SERVER}system/COMP_AnnouncementCategory/Put`, data),
  };
}

export function fetchInternalSystemLink(page = 1) {
  const pageSize = 5;
  return {
    type: FETCH_INTERNAL_SYSTEM_LINK,
    payload: new Promise((resolve, reject) => {
      axios.get(`${url.SECURITY_API_SERVER}system/COMP_InternalSystemLink/Get`, {
        params: {
          $top: pageSize,
          $skip: (page - 1) * pageSize,
          $inlinecount: 'allpages',
        },
      }).then((response) => {
        resolve({
          response,
          pageNumber: page,
        });
      }).catch((error) => {
        reject(error);
      });
    }),
  };
}

const isDevEnv = window.location.origin.indexOf('dev.mayohr.com') >= 0;
const buildFormData = (data) => {
  const formData = new FormData();
  Object.keys(data).map((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key.replace(/^./, key[0].toUpperCase()), data[key]);
    }
  });
  return formData;
};

export function addInternalSystemLink(data) {
  const formData = buildFormData(Object.assign({}, data, { ApiUrl: 'api/system/COMP_InternalSystemLink/Post' }));
  return {
    type: ADD_INTERNAL_SYSTEM_LINK,
    payload: axios.post(`${isDevEnv ? 'https://tst-hrm-frontend.mayohr.com/' : window.location.origin}/api/PutFile/PutFile`,
    formData,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }),
  };
}

export function updateInternalSystemLink(data) {
  const formData = buildFormData(Object.assign({}, data, { ApiUrl: 'api/system/COMP_InternalSystemLink/Put' }));
  return {
    type: UPDATE_INTERNAL_SYSTEM_LINK,
    payload: axios.post(`${isDevEnv ? 'https://tst-hrm-frontend.mayohr.com/' : window.location.origin}/api/PutFile/PutFile`,
    formData,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }),
  };
}

export function deleteInternalSystemLink(internalSystemLinkId) {
  return {
    type: DELETE_INTERNAL_SYSTEM_LINK,
    payload: axios.delete(`${url.SECURITY_API_SERVER}system/COMP_InternalSystemLink/Delete`, {
      params: {
        id: internalSystemLinkId,
      },
    }),
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanySpace/screens/SiteSetting/reducers/index.js
 **/